import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
interface Step {
  number: string;
  title: string;
  highlightWord: string;
  description: string;
  icon: string;
}
@Component({
  selector: 'app-lottery-landing',
  imports: [CommonModule],
  templateUrl: './lottery-landing.component.html',
  styleUrl: './lottery-landing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotteryLandingComponent {
  constructor(private router: Router) {}
  redirectToSignUp() {
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigate(['/dashboard/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
